import { TLC_CONSTANTS } from "../../../../js/lib/tlc-constants";
import { TLCEventManager } from "../../../../js/lib/events/EventManager";
import { TLCEXT } from "../../../../js/lib/ext/Ext";
import { LS2PAC_CONSTANTS } from "../../../../js/main/constants";
import { EventableMixin } from "../../events/EventableMixin";
import { ApplicationData } from "../ApplicationData";

export class WorldBookDatabaseControl {
	constructor(options) {
		options = options || {};

		$.extend(true, this, {
			id: LS2PAC_CONSTANTS.Ids.SearchPage.worldBookControl,
			containerId: LS2PAC_CONSTANTS.Ids.SearchPage.worldBookOptionsContainer,
			events: [
				TLC_CONSTANTS.Events.onPagingModelResponse,
				LS2PAC_CONSTANTS.Events.onSearch,
				LS2PAC_CONSTANTS.Events.onLogoutResponse,
				LS2PAC_CONSTANTS.Events.onTimeout,
				LS2PAC_CONSTANTS.Events.onHome
			],
			optionExt: TLCEXT.Template("<option value=\"{value}\">{name}</option>"),
			currentDb: null,
			defaultDb: null,
			hasEvents: false,
			options: ApplicationData.locationConfiguration.getWorldBookDatabases()
		}, options);

		this.renderOptions();
		this.addAdditionalEvents();
	}
	cleanUp() {
		$("#" + this.containerId).off("change", "#" + this.id) ;
		this.removeListenerFunctions.forEach((remove) => remove());
	}
	renderOptions(event) {
		var _this = this;
		var selectBox = $("#" + this.id);

		selectBox.attr(LS2PAC_CONSTANTS.CssClasses.disabled, LS2PAC_CONSTANTS.CssClasses.disabled);
		selectBox.empty();

		var firstEnabledItem = null;

		$.each(this.options, function (index, item) {
			if (item.useThis) {
				if (!firstEnabledItem) {
					firstEnabledItem = item;
				}

				selectBox.append(_this.optionExt.populate(item));
				if (item.defaultDb) {
					_this.defaultDb = item;
				}
			}
		});

		if (!this.defaultDb) {
			this.defaultDb = firstEnabledItem;
		}

		selectBox.val(this.defaultDb.value);

		selectBox.prop("disabled", false);
	}
	addAdditionalEvents(event) {
		var _this = this;
		this.addEvents();

		$("#" + this.containerId).on("change", "#" + this.id, function (event) {
			_this.currentDb = event.currentTarget.value;
			TLCEventManager.fireEvent(LS2PAC_CONSTANTS.Events.onChangeWorldBookDatabase, { database: _this.currentDb });
			$(event.currentTarget).attr(LS2PAC_CONSTANTS.CssClasses.disabled, LS2PAC_CONSTANTS.CssClasses.disabled);
			// Fire world book search with new db option
		});


	}
	reset(switchToDefault) {
		var selectBox = $("#" + this.id);
		if (switchToDefault) {
			selectBox.val(this.defaultDb.value);
			this.currentDb = this.defaultDb;
			TLCEventManager.fireEvent(LS2PAC_CONSTANTS.Events.onChangeWorldBookDatabase, { database: this.currentDb.value });
		}
		selectBox.prop("disabled", false); 
	}
}

WorldBookDatabaseControl.prototype[TLC_CONSTANTS.Events.onPagingModelResponse] = function ( event ) {
	if( event.success && event.data.hasWorldBookControl && this.options.length > 1 ) {
		$( "#" + this.id ).prop("disabled", false);
	} 
};

WorldBookDatabaseControl.prototype[LS2PAC_CONSTANTS.Events.onHome] = function ( event ) {
	this.reset(true);
};

WorldBookDatabaseControl.prototype[LS2PAC_CONSTANTS.Events.onLogoutResponse] = function ( event ) {
	this.reset(true);
};

WorldBookDatabaseControl.prototype[LS2PAC_CONSTANTS.Events.onSearch] = function ( event ) {
	this.reset();
};

EventableMixin.call( WorldBookDatabaseControl.prototype );
